import React from 'react';
import { History } from 'history';
import { Input, InputNumber, InputMultiline, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import BaseView from '../base/base-view.component';
import Model from './section-model';  //editable..
import OwnerPicklist from '../owner/owner-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    caption?: string;
    tag?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class SectionCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private historyState: any = this.props.history.location.state;

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadParent = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'parent': data?.id, 'parentCaption': data?.name || ''  }  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..      
            <>     
            {this.historyState?.id > 0 &&
            <BaseView history={this.props.history} caption=''
                model={Model} onLoad={this.onLoadParent}/>
            }        
            <BaseCreate history={this.props.history} caption={this.props.caption}
                model={Model} datarow={this.state.datarow} onError={this.onError} disableAutoBack>              
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                {this.historyState?.id > 0 &&
                <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                }
                <Input name='title' label='Title' value={this.state.datarow.title} error={this.state.errors?.title} onChange={this.onChange} />
                <InputMultiline name='content' label='Content' value={this.state.datarow.content} error={this.state.errors?.content} onChange={this.onChange} />
                <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} error={this.state.errors?.seq} onChange={this.onChange} />
                <InputSelect name='viewstyle' label='View Style' value={this.state.datarow.viewstyle} options={Model.optionViewstyle} error={this.state.errors?.viewstyle} onChange={this.onChange} />
                <InputNumber name='timelimit' label='Time Limit (Seconds)' value={this.state.datarow.timelimit} error={this.state.errors?.timelimit} onChange={this.onChange} />
                <InputNumber name='questiontolerance' label='Question Tolerances' value={this.state.datarow.questiontolerance} error={this.state.errors?.questiontolerance} onChange={this.onChange} />
                <Input name='tag' label='Tag' value={this.state.datarow.tag} error={this.state.errors?.tag} onChange={this.onChange} />
                
            </BaseCreate>
            </>
        );
    }     
     
}